import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zapper',
  templateUrl: './zapper.component.html',
  styleUrls: ['./zapper.component.scss']
})
export class ZapperComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
